import { Observable, PartialObserver, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { ENV } from "../app/app.runtime";
import { WebsocketService } from "./websocket.service";

export class WebsocketListener<M> {
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  public messages: Observable<M>;
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  private subscriber: Subscription;

  constructor(private wsService: WebsocketService) {}

  public listen(url: string, handlers: PartialObserver<M>) {
    const parseJson = map(
      // Casting because impossible to know type here
      (response: MessageEvent): M => JSON.parse(response.data) as M,
    );

    const connection = this.wsService.connect(this.webserviceUrl(url));
    this.messages = connection.pipe(parseJson);
    this.subscriber = this.messages.subscribe(handlers);
  }

  public close() {
    this.subscriber.unsubscribe();
    this.wsService.close();
  }

  private webserviceUrl(url: string) {
    const apiUrl = ENV.NWD_API_BASE_URL.replace(/^https:\/\//i, "wss://");
    return apiUrl + url;
  }
}
